export class ColumnReport {
  field: string;
  alignData: string;
  width: number;
  title: string;
}

export class Report {
    public title: string;
    public columns: ColumnReport[]
    public data: any[];
    public company: {
      id: number,
      name: string
    };
  }



// WEBPACK FOOTER //
// ./src/app/models/report.model.ts